export class TableColumn {
  id;
  field;
  headerName;
  description;
  sortable;
  flex;
  valueGetter;
  renderCell;
  minWidth;
  cellClassName;
  sortComparator;

  constructor(
    id = 1,
    field = "",
    headerName = "",
    renderCell = null,
    valueGetter = null,
    sortable = true,
    minWidth = 170,
    cellClassName = null,
    flex = 1
  ) {
    this.id = id;
    this.field = field;
    this.headerName = headerName;
    this.flex = flex;
    this.renderCell = renderCell;
    this.minWidth = minWidth;
    this.cellClassName = cellClassName;
    this.sortable = sortable;
    if(sortable){
      this.sortComparator = this.sort;
    }
    this.valueGetter = valueGetter;
  }
  sort = (v1, v2) => {
    if (v1 instanceof Date && v2 instanceof Date) {
      // handle date
      if (v1 < v2) {
        return -1; // put before
      }
      if (v1 > v2) {
        return 1;  // put after
      }
      return 0;    // no change
    }
    else if (!isNaN(v1) && !isNaN(v2)) {
      // handle numeric
      v1 = v1?.toString();
      v2 = v2?.toString();
      return v1?.localeCompare(v2, undefined, { numeric: true });
    }
    else {
      // handle strings
      if (v1 && v2) {
      return v1?.localeCompare(v2);
    } else {
      if (v1) {
        return 1;
      }
      else {
        return -1;
      }
    }
    }
  };
}
